import '@externs/goa'
import '../types/externs'
import cors from './'

module.exports = {
  '_cors': cors,
}